import React, {useEffect, useState} from 'react';
import {Box, Container, styled} from '@mui/material';
import Typography from '@mui/material/Typography';
import {useOutletContext, useParams} from 'react-router-dom';
import {
    downloadSchoolDocument,
    useGetSchoolDocumentsQuery,
} from '../../../api/services/filesService';
import useFileDownloader from '../../../utility/hooks/useFileDownloader';
import DocumentList from '../Profiles/Components/DocumentList';

const DocumentFields = styled(Container)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    padding: 0
});

const EmployeeProfileDocumentsTab = () => {
    const {id: routeEmployeeId} = useParams();
    const {data: employee} = useOutletContext() || {};
    const employeeId = routeEmployeeId ? Number(routeEmployeeId) : employee?.id;
    const [schoolDocuments, setSchoolDocuments] = useState([]);
    const [paginationModel, setPaginationModel] = useState({
        pageNumber: 0,
        pageSize: 20,
        hasMore: true
    });

    const {
        data: schoolDocumentsPage,
        isLoading: isSchoolDocumentsLoading
    } = useGetSchoolDocumentsQuery(
        {
            ...paginationModel,
            employeeId: Number(employeeId)
        },
        {skip: !employeeId}
    );

    const downloadFile = useFileDownloader();

    useEffect(() => {
        setSchoolDocuments([]);
        setPaginationModel({
            pageNumber: 0,
            pageSize: 20,
            hasMore: true
        });
    }, [employeeId]);

    useEffect(() => {
        if (schoolDocumentsPage && !isSchoolDocumentsLoading) {
            setSchoolDocuments(current => [...current, ...schoolDocumentsPage.items]);
            setPaginationModel(current => ({
                ...current,
                hasMore: schoolDocumentsPage.items.length > 0
            }));
        }
    }, [schoolDocumentsPage, isSchoolDocumentsLoading]);

    const handleScrollSchoolDocumentList = event => {
        const {scrollTop, clientHeight, scrollHeight} = event.currentTarget;

        if (paginationModel.hasMore &&
            scrollHeight - scrollTop === clientHeight &&
            !isSchoolDocumentsLoading
        ) {
            setPaginationModel(current => ({
                ...current,
                pageNumber: current.pageNumber + 1
            }));
        }
    };

    const employeeName = employee
        ? `${employee.legalForename || employee.preferredForename || ''} ${employee.legalSurname || employee.preferredSurname || ''}`.trim()
        : 'you';

    const documentsMap = [
        {
            sectionName: 'School Documents',
            documents: schoolDocuments,
            paginationHandler: handleScrollSchoolDocumentList,
            onDownload: async documentId => await downloadFile(
                downloadSchoolDocument,
                {documentId, employeeId: Number(employeeId)}
            )
        }
    ];

    if (!employeeId) {
        return null;
    }

    return (
        <DocumentFields>
            {schoolDocuments.length === 0 && !isSchoolDocumentsLoading
                ? (
                    <Box display={'flex'} justifyContent={'center'} py={2}>
                        <Typography color={'silver'} variant={'h6'}>
                            No documents available for {employeeName}
                        </Typography>
                    </Box>
                )
                : null}
            <DocumentList documents={documentsMap}/>
        </DocumentFields>
    );
};

export default EmployeeProfileDocumentsTab;
